import axios from 'axios';
import { CompanyWithDocAndMeta } from 'models/response';
import { UploadFile } from 'models/request';
import { FILESERVICE } from 'utils/constants';
import { trackPromise } from 'react-promise-tracker';

/**
 *  This API returns all companies and document types
 * @param {Object} body
 * @param {number} body.idUser
 * @param {number} body.idProgram
 * @return {Promise<AxiosResponse<CompanyWithDocAndMeta[]>>}
 */
const getCompanyWithDocsAndMetadataByProgram = (body: { idUser: number; idProgram: number }) =>
  trackPromise(
    axios.post<CompanyWithDocAndMeta[]>(`${FILESERVICE}/getCompanyWithDocsAndMetadataByProgram`, body),
    'module',
  );

/**
 *  Upload file
 * @param {Object} body
 * @param {number} body.idUser
 * @param {number} body.idCompany
 * @param {number} body.idDocType
 * @param {string} body.pdfBase64
 * @param {string} body.splitString
 * @param {string} body.fileName
 * @param {any} body.uploaderFields
 * @param {PageAction} body.pageAction
 * @param {function} onProgress
 * @return {Promise<AxiosResponse>}
 */
const uploadFile = (body: UploadFile, onProgress?: (progress: number) => void) => {
  const onUploadProgress = (event: any) => {
    const percentCompleted = Math.round((event.loaded * 100) / event.total);
    onProgress && onProgress(percentCompleted);
  };
  return trackPromise(axios.post(`${FILESERVICE}/uploadFile`, body, { onUploadProgress }), 'PDFUpload');
};

export default {
  getCompanyWithDocsAndMetadataByProgram,
  uploadFile,
};
